"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tap_stream_core_1 = require("./tap-stream-core");
exports.TapStreamReader = tap_stream_core_1.TapStreamReader;
exports.TapStreamWriter = tap_stream_core_1.TapStreamWriter;
